import React, { JSX } from 'react';
import {
    List,
    TextField,
    Datagrid,
    ShowButton, ReferenceField,
    SelectField
} from 'react-admin';
import { invoiceTypes } from "../../defaults/defaults";

export const SubscriptionInvoiceList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ false }

        >
            <Datagrid bulkActionButtons={ false } >
                <TextField source="id" />
                <TextField source="status"  sx={ { textTransform: 'uppercase' } } />
                <TextField source="amountPaid"/>
                <TextField source="invoiceId" label={ "Invoice ID" } />
                <SelectField source="invoiceType" choices={ invoiceTypes } />
                <ReferenceField source="customerAccount" reference="customer_accounts" />
                {/* No gate here on purpose: react-admin asks `authProvider.canAccess` for this button
                itself, and the map there names the verb. A check beside it would be the same
                rule written twice. */}
                    <ShowButton label="View" />

            </Datagrid>
        </List>
    );
}
